import { Tag } from 'antd';
import styled from 'styled-components';

const StyledTag = styled(Tag)`
	border-radius: 25px;
`;

export default StyledTag;
